/**
 * カスタム翻訳オーバーライドサンプル
 * 特定のメッセージのみを上書きする効率的な方法
 * 
 * 使用例：「コード」→「プログラム」の置き換え
 */

// 特定のメッセージのみをオーバーライド
const messageOverrides = {
    // 日本語
    ja: {
        // 削除確認モーダル
        'gui.gui.shouldDeleteSprite': 'このスプライトを削除しますか？',
        'gui.gui.shouldDeleteCostume': 'このコスチュームを削除しますか？',
        'gui.gui.shouldDeleteSound': 'この音を削除しますか？',
        'gui.gui.confirm': 'はい',
        'gui.gui.cancel': 'いいえ',
        'gui.gui.deleteAssetHeading': 'アセット削除の確認',

        // ペイントエディターツールの不足翻訳を補完
        'paint.modeTools.select': '選択',
        'paint.modeTools.reshape': '変形',
        'paint.modeTools.brush': 'ブラシ',
        'paint.modeTools.eraser': '消しゴム',
        'paint.modeTools.fill': '塗りつぶし',
        'paint.modeTools.text': 'テキスト',
        'paint.modeTools.line': '線',
        'paint.modeTools.oval': '円',
        'paint.modeTools.rect': '四角形',

        // スプライト情報バー用ラベル
        'gui.SpriteInfo.spriteName': 'スプライト名',

        // ステージセレクター
        'gui.stageSelector.stage': 'ステージ',

        // ライブラリタグ（音）
        'gui.libraryTags.nature': '自然',
        'gui.libraryTags.fighting': '格闘',
        'gui.libraryTags.weapons': '武器',
        'gui.libraryTags.magic': '魔法',
        'gui.libraryTags.monsters': 'モンスター'
    },

    // 日本語（ひらがな）
    'ja-Hira': {
        // 削除確認モーダル
        'gui.gui.shouldDeleteSprite': 'このスプライトをけしますか？',
        'gui.gui.shouldDeleteCostume': 'このコスチュームをけしますか？',
        'gui.gui.shouldDeleteSound': 'このおとをけしますか？',
        'gui.gui.confirm': 'はい',
        'gui.gui.cancel': 'いいえ',
        'gui.gui.deleteAssetHeading': 'さくじょのかくにん',

        // スプライト情報バー用ラベル
        'gui.SpriteInfo.spriteName': 'スプライトめい',

        // ステージセレクター
        'gui.stageSelector.stage': 'ステージ',

        // ライブラリタグ（おと）
        'gui.libraryTags.nature': 'しぜん',
        'gui.libraryTags.fighting': 'かくとう',
        'gui.libraryTags.weapons': 'ぶき',
        'gui.libraryTags.magic': 'まほう',
        'gui.libraryTags.monsters': 'モンスター'
    },

    // 英語 (Code → Program)
    en: {
        'gui.gui.codeTab': 'Program',
        'gui.codeTab.code': 'Program',

        // 削除確認モーダル（念のため英語も追加）
        'gui.gui.shouldDeleteSprite': 'Are you sure you want to delete this sprite?',
        'gui.gui.shouldDeleteCostume': 'Are you sure you want to delete this costume?',
        'gui.gui.shouldDeleteSound': 'Are you sure you want to delete this sound?',
        'gui.gui.confirm': 'Yes',
        'gui.gui.cancel': 'No',
        'gui.gui.deleteAssetHeading': 'Confirm Asset Deletion',

        // スプライト情報バー用ラベル
        'gui.SpriteInfo.spriteName': 'Sprite Name',

        // ステージセレクター
        'gui.stageSelector.stage': 'Stage',

        // Library tags (sounds)
        'gui.libraryTags.nature': 'Nature',
        'gui.libraryTags.fighting': 'Fighting',
        'gui.libraryTags.weapons': 'Weapons',
        'gui.libraryTags.magic': 'Magic',
        'gui.libraryTags.monsters': 'Monsters'
    },

    // スペイン語 (Código → Programa)
    es: {
        'gui.gui.codeTab': 'Programa',
        'gui.codeTab.code': 'Programa',

        // 削除確認モーダル
        'gui.gui.shouldDeleteSprite': '¿Estás seguro de que quieres eliminar este sprite?',
        'gui.gui.shouldDeleteCostume': '¿Estás seguro de que quieres eliminar este disfraz?',
        'gui.gui.shouldDeleteSound': '¿Estás seguro de que quieres eliminar este sonido?',
        'gui.gui.confirm': 'Sí',
        'gui.gui.cancel': 'No',
        'gui.gui.deleteAssetHeading': 'Confirmar eliminación de recurso',

        // スプライト情報バー用ラベル
        'gui.SpriteInfo.spriteName': 'Nombre del Sprite',

        // ステージセレクター
        'gui.stageSelector.stage': 'Escenario',

        // Etiquetas de biblioteca (sonidos)
        'gui.libraryTags.nature': 'Naturaleza',
        'gui.libraryTags.fighting': 'Lucha',
        'gui.libraryTags.weapons': 'Armas',
        'gui.libraryTags.magic': 'Magia',
        'gui.libraryTags.monsters': 'Monstruos'
    },

    // フランス語 (Code → Programme)
    fr: {
        'gui.gui.codeTab': 'Programme',
        'gui.codeTab.code': 'Programme',

        // 削除確認モーダル
        'gui.gui.shouldDeleteSprite': 'Êtes-vous sûr de vouloir supprimer ce sprite ?',
        'gui.gui.shouldDeleteCostume': 'Êtes-vous sûr de vouloir supprimer ce costume ?',
        'gui.gui.shouldDeleteSound': 'Êtes-vous sûr de vouloir supprimer ce son ?',
        'gui.gui.confirm': 'Oui',
        'gui.gui.cancel': 'Non',
        'gui.gui.deleteAssetHeading': 'Confirmer la suppression de la ressource',

        // スプライト情報バー用ラベル
        'gui.SpriteInfo.spriteName': 'Nom du Sprite',

        // ステージセレクター
        'gui.stageSelector.stage': 'Scène',

        // Étiquettes de bibliothèque (sons)
        'gui.libraryTags.nature': 'Nature',
        'gui.libraryTags.fighting': 'Combat',
        'gui.libraryTags.weapons': 'Armes',
        'gui.libraryTags.magic': 'Magie',
        'gui.libraryTags.monsters': 'Monstres'
    },

    // 中国語（簡体字）
    'zh-cn': {
        'gui.gui.codeTab': '程序',
        'gui.codeTab.code': '程序',

        // 削除確認モーダル
        'gui.gui.shouldDeleteSprite': '您确定要删除这个角色吗？',
        'gui.gui.shouldDeleteCostume': '您确定要删除这个造型吗？',
        'gui.gui.shouldDeleteSound': '您确定要删除这个声音吗？',
        'gui.gui.confirm': '是',
        'gui.gui.cancel': '否',
        'gui.gui.deleteAssetHeading': '确认删除资源',

        // スプライト情報バー用ラベル
        'gui.SpriteInfo.spriteName': '角色名称',

        // ステージセレクター
        'gui.stageSelector.stage': '舞台',

        // 库标签（声音）
        'gui.libraryTags.nature': '自然',
        'gui.libraryTags.fighting': '格斗',
        'gui.libraryTags.weapons': '武器',
        'gui.libraryTags.magic': '魔法',
        'gui.libraryTags.monsters': '怪物'
    }
};

/**
 * 公式メッセージにカスタムオーバーライドを適用
 * @param {object} officialMessages - scratch-l10nからの公式メッセージ
 * @returns {object} オーバーライド適用済みメッセージ
 */
export const applyMessageOverrides = (officialMessages) => {
    const result = {};
    
    // 各言語に対してオーバーライドを適用
    Object.keys(officialMessages).forEach(locale => {
        result[locale] = {
            ...officialMessages[locale], // 公式メッセージをベースに
            ...(messageOverrides[locale] || {}) // カスタムオーバーライドを上書き
        };
    });
    
    return result;
};

/**
 * 新しいオーバーライドを追加する関数
 * @param {string} locale - 言語コード（ja, en, es, fr等）
 * @param {string} messageId - メッセージID（例: 'gui.gui.codeTab'）
 * @param {string} customText - カスタムテキスト
 */
export const addMessageOverride = (locale, messageId, customText) => {
    if (!messageOverrides[locale]) {
        messageOverrides[locale] = {};
    }
    messageOverrides[locale][messageId] = customText;
};

/**
 * 複数のオーバーライドを一度に追加
 * @param {string} locale - 言語コード
 * @param {object} overrides - オーバーライドオブジェクト
 */
export const addMultipleOverrides = (locale, overrides) => {
    if (!messageOverrides[locale]) {
        messageOverrides[locale] = {};
    }
    messageOverrides[locale] = {
        ...messageOverrides[locale],
        ...overrides
    };
};

/**
 * 現在のオーバーライド設定を取得
 * @returns {object} 現在のオーバーライド設定
 */
export const getMessageOverrides = () => {
    return messageOverrides;
};

export default messageOverrides;

/* 
===============================
使用方法：
===============================

1. locales.jsで使用する場合：

import editorMessages from 'scratch-l10n/locales/editor-msgs';
import {applyMessageOverrides} from '../lib/custom-messages';

const initialState = {
    isRtl: false,
    locale: 'ja',
    messagesByLocale: applyMessageOverrides(editorMessages), // ← オーバーライド適用
    messages: applyMessageOverrides(editorMessages).ja
};

2. 新しいオーバーライドを追加する場合：

import {addMessageOverride} from '../lib/custom-messages';

// 単一追加
addMessageOverride('ja', 'gui.gui.soundsTab', '効果音');
addMessageOverride('en', 'gui.gui.soundsTab', 'Audio');

// 複数追加
addMultipleOverrides('ja', {
    'gui.gui.soundsTab': '効果音',
    'gui.gui.costumesTab': '見た目'
});

3. よく変更される可能性のあるメッセージID：

- 'gui.gui.codeTab': メインタブの「コード」
- 'gui.gui.costumesTab': メインタブの「コスチューム」  
- 'gui.gui.soundsTab': メインタブの「音」
- 'gui.gui.backdropsTab': メインタブの「背景」
- 'gui.stageSelector.stage': 「ステージ」
- 'gui.spriteSelector.sprite': 「スプライト」
- 'gui.menuBar.file': メニューの「ファイル」
- 'gui.menuBar.edit': メニューの「編集」

===============================
*/